export const OPEN_TOFU_MIGRATION_PATH = "/opentofu-migration";
export const OPEN_TOFU_MIGRATION_QUEUE_PATH = "/opentofu-migration/queue";

export const OPEN_TOFU_MIGRATION_DASHBOARD_PATH = "/dashboard";

export const OPEN_TOFU_MIGRATION_TITLE = "Migrate stacks to OpenTofu";

export const OPEN_TOFU_MIGRATION_INITIAL_LIMIT = 50;
